import React from 'react';
import { Helmet } from 'react-helmet';
import Hero from '../components/Hero/Hero';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Michael and Ashlynn's Wedding</title>
        <meta name="description" content="Join us in celebrating our special day" />
        
        {/* Open Graph Meta Tags for regular wedding site preview */}
        <meta property="og:title" content="Michael and Ashlynn's Wedding" />
        <meta property="og:description" content="Join us in celebrating our special day" />
        <meta property="og:image" content={`${window.location.origin}/Venue_1200.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Michael and Ashlynn's Wedding" />
        <meta property="og:url" content={window.location.href} />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Michael and Ashlynn's Wedding" />
        <meta name="twitter:description" content="Join us in celebrating our special day" />
        <meta name="twitter:image" content={`${window.location.origin}/Venue_1200.jpg`} />
      </Helmet>
      
      <main className="page">
        <Hero />
      </main>
    </>
  );
};

export default HomePage; 